import { frontendURL } from '../../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import KnowledgebaseHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/knowledge-base'),
      component: SettingsWrapper,
      children: [
        {
          path: 'list',
          name: 'knowledgebase_list',
          meta: {
            permissions: ['administrator', ...CONVERSATION_PERMISSIONS],
          },
          component: KnowledgebaseHome,
        },
      ],
    },
  ],
};
